import {get, cloneDeep} from 'lodash';
import BaseService from '../../../middleware/BaseService';

class PublishDvrStateChangeService extends BaseService {
  prefix = '/dvr/desireState/publish';

  async publishState(_desiredState) {
    const desiredState = cloneDeep(_desiredState);
    await this.post(desiredState);
    return _desiredState;
  }
}

export default new PublishDvrStateChangeService();
